let bundleProductPriceSum = 0;
let bundleSavedSum = 0;
class QuickBuy extends HTMLElement {
  constructor() {
    super()
    this.button = this.querySelector('[data-quick-buy-btn]')
    this.buttonText = this.querySelector('[data-quick-buy-btn] span')
    this.buttonLoader = this.querySelector('.loading-overlay__spinner')
    this.cartItems = null
    this.VariantRadios = this.querySelector('variant-radios')
    this.variantIds = this.getAttribute('variant-ids')
    this.properties = this.getAttribute('line-item-props')
    this.error = this.querySelector('.product-quickbuy__error-message-wrapper')
    this.errorMessageText = this.querySelector('.product-quickbuy__error-message')
    this.allowedValues = ['color', 'colour']
    this.colourName = this.querySelector('.product-connections .form__label span')
    this.colourGroup = this.querySelector('other-colours')
    this.gridCollection = document.getElementById('ProductGridContainer')
    this.sectionsToRender = []
    this.variantData = null
    this.productInfoCache = new Map()
    this.isGift = this.dataset.isGift
    this.swatchHiddenClass = 'hidden-mobile'
    this.plusMoreShowClass = ``
    this.isBundlePage = this.hasAttribute('data-bundle-page')
    this.bundleGridStep = this.dataset.bundleGridStepCta
    if (this.VariantRadios) {
      this.plusMoreShowClass = `[data-target="quickbuyitem-${this.VariantRadios.dataset.section}"] .colour-swatch .plus-more.show-mobile`
      if (window.innerWidth > 749) {
        this.swatchHiddenClass = 'hidden-desktop'
        this.plusMoreShowClass = `[data-target="quickbuyitem-${this.VariantRadios.dataset.section}"] .colour-swatch .plus-more.show-desktop`
      }
      this.shadeTrigger = document.querySelector(`[data-trigger="quickbuyitem-${this.VariantRadios.dataset.section}"]`)
      this.shadeTarget = document.querySelectorAll(`[data-target="quickbuyitem-${this.VariantRadios.dataset.section}"] .colour-swatch .colour.flex-rows`)
      this.shadeTargetPlus = document.querySelector(this.plusMoreShowClass)
      this.mobileATC = document.querySelector(`[data-trigger="quickbuyatc-${this.VariantRadios.dataset.section}"]`)
    }
    if (!this.button) return
    this.button.addEventListener('click', this.onClickHandler.bind(this))
    this.addEventListener('change', this.onVariantChange.bind(this))
    if (this.shadeTrigger) {
      this.shadeTrigger.addEventListener('click', this.onClickHandlershadeTrigger.bind(this))
      this.shadeTargetPlus?.addEventListener('click', this.onClickHandlershadeTrigger.bind(this))
    }
    if (this.colourGroup) {
      Array.from(this.colourGroup.querySelectorAll('a.colour')).forEach(colour => {
        colour.addEventListener('click', this.onClickHandlerGroupColor.bind(this))
      })
    }
  }
  getCartComponent() {
    const cartDrawer = document.querySelector('cart-drawer')
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function' && typeof cartDrawer.renderContents === 'function') return cartDrawer
    const cartPage = document.querySelector('cart-items')
    if (cartPage && typeof cartPage.getSectionsToRender === 'function') return cartPage
    return null
  }
  getSectionsForFetch(cartComponent) {
    if (!cartComponent || typeof cartComponent.getSectionsToRender !== 'function') return []
    try {
      return cartComponent.getSectionsToRender().map(section => section.section || section.id).filter(Boolean)
    } catch (error) {
      console.error('QuickBuy getSectionsForFetch error:', error)
      return []
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML
  }
  renderCartContents(cartComponent, parsedState) {
    if (!cartComponent || !parsedState?.sections) return
    if (cartComponent.matches('cart-items')) {
      cartComponent.classList.toggle('is-empty', parsedState.item_count === 0)
      document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0)
      document.querySelector('cart-drawer')?.classList.toggle('is-empty', parsedState.item_count === 0)
      let sectionsToRender = []
      try {
        sectionsToRender = cartComponent.getSectionsToRender()
      } catch (error) {
        console.error('QuickBuy renderCartContents error:', error)
        return
      }
      sectionsToRender.forEach(section => {
        const sectionId = section.section || section.id
        const selector = section.selector || section.selectors
        if (!sectionId || !selector || !parsedState.sections[sectionId]) return
        const elementToReplace = section.selectors ? document.querySelector(section.selectors) : document.getElementById(section.id)?.querySelector(selector) || document.getElementById(section.id)
        if (!elementToReplace) return
        const newHTML = this.getSectionInnerHTML(parsedState.sections[sectionId], selector)
        if (newHTML == null) return
        elementToReplace.innerHTML = newHTML
      })
      const cartAdditionalData = document.querySelector('.cart-additional-data')
      const sessionCartAdditionalData = sessionStorage.getItem('cart-additional')
      if (cartAdditionalData && sessionCartAdditionalData) cartAdditionalData.innerHTML = sessionCartAdditionalData
      if (typeof cartComponent.handleQuantityLimits === 'function') cartComponent.handleQuantityLimits()
      if (window.Nosto) Nosto.reloadCart(['cart-upsell'])
      return
    }
    if (typeof cartComponent.renderContents === 'function') {
      cartComponent.renderContents(parsedState)
      cartComponent.classList.remove('is-empty')
    }
  }
  onClickHandlershadeTrigger() {
    if (this.shadeTarget) {
      Array.from(this.shadeTarget).forEach(shadeTargetItem => shadeTargetItem.classList.remove(this.swatchHiddenClass))
    }
    if (this.mobileATC) this.mobileATC.classList.remove('hidden')
    if (this.shadeTrigger) this.shadeTrigger.classList.add('hidden')
    if (this.shadeTargetPlus) this.shadeTargetPlus.classList.add('hidden')
  }
  onVariantChange() {
    this.classList.add('loading')
    this.querySelector('.loading-overlay.product-loading')?.classList.remove('hidden')
    this.updateOptions()
    this.updateMasterId()
    this.handleErrorMessage()
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
      return
    }
    this.updateVariantInput()
    this.updateMedia()
    this.renderProductInfo()
  }
  onProductChange() {
    this.updateOptions()
    this.updateMasterId()
    this.handleErrorMessage()
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
      return
    }
    this.updateVariantInput()
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
  }
  updateOptions() {
    const fieldsets = Array.from(this.VariantRadios.querySelectorAll('fieldset'))
    this.options = fieldsets.map(fieldset => {
      const checkedInput = fieldset.querySelector('input:checked')
      if (!checkedInput) return null
      const optionName = checkedInput.name.split('-').pop().toLowerCase()
      if (this.colourName && this.allowedValues.includes(optionName)) this.colourName.innerHTML = checkedInput.value
      return checkedInput.value
    })
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options.map((option, index) => this.options[index] === option).includes(false)
    })
  }
  updateVariantInput() {
    this.setAttribute('variant-ids', this.currentVariant.id)
    this.variantIds = this.getAttribute('variant-ids')
  }
  getVariantData() {
    if (!this.variantData) {
      const variantDataEl = this.querySelector('[type="application/json"]')
      this.variantData = variantDataEl ? JSON.parse(variantDataEl.textContent) : []
    }
    return this.variantData
  }
  getCurrentFeatureImage(productImage = false) {
    if (!this.currentVariant) return ''
    if (this.currentVariant.featured_media) return this.currentVariant.featured_media.preview_image.src
    return productImage || ''
  }
  updateMediaElement(mediaAttribute, productImage = false) {
    const currentFeature = this.getCurrentFeatureImage(productImage)
    if (!currentFeature) return
    const imgSizes = ['165', '360', '533', '720', '940', '1066']
    const format = '.' + currentFeature.split('.').reverse()[0]
    const itemMedia = document.querySelector(`.product-${this.VariantRadios.dataset.section} [${mediaAttribute}="${this.VariantRadios.dataset.section}"]`)
    if (!itemMedia) return
    const srcImg = currentFeature.replace(format, '_' + imgSizes[2] + 'x' + format)
    const srcSizes = imgSizes.map(size => currentFeature.replace(format, '_' + size + 'x' + format + ' ' + size + 'w')).join(',')
    itemMedia.src = srcImg
    itemMedia.srcset = srcSizes
  }
  updateMedia(productImage = false) {
    this.updateMediaElement('data-media-id', productImage)
  }
  updateMediaSecond(productImage = false) {
    this.updateMediaElement('data-media-second-id', productImage)
  }
  renderProductInfo() {
    const url = `${this.VariantRadios.dataset.url}?variant=${this.currentVariant.id}`
    const updateFromText = responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      this.updateProductInfoFromHTML(html)
    }
    if (this.productInfoCache.has(url)) {
      updateFromText(this.productInfoCache.get(url))
      this.hideProductLoading()
      return
    }
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        this.productInfoCache.set(url, responseText)
        updateFromText(responseText)
      })
      .finally(() => this.hideProductLoading())
  }
  updateProductInfoFromHTML(html) {
    const priceSource = html.querySelector('.product .price .price__container')
    const priceSelector = `.product-${this.VariantRadios.dataset.section} .product-price`
    const variantTitleSelector = `.product-${this.VariantRadios.dataset.section} .product-variant`
    if (priceSource) {
      document.querySelectorAll(priceSelector).forEach(priceDestination => {
        priceDestination.innerHTML = priceSource.innerHTML
      })
    }
    if (this.currentVariant.title && this.currentVariant.title !== 'Default Title') {
      document.querySelectorAll(variantTitleSelector).forEach(variantTitleDestination => {
        variantTitleDestination.innerHTML = this.currentVariant.title
      })
    }
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
  }
  hideProductLoading() {
    this.querySelector('.loading-overlay.product-loading')?.classList.add('hidden')
    this.classList.remove('loading')
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    if (!this.button) return
    if (disable) {
      this.button.setAttribute('aria-disabled', true)
      this.hideProductLoading()
      if (text) this.buttonText.textContent = text
      return
    }
    this.button.removeAttribute('aria-disabled')
    this.buttonText.textContent = window.variantStrings.addToCart
  }
  setUnavailable() {
    if (!this.button) return
    this.buttonText.textContent = window.variantStrings.unavailable
    const price = document.querySelector(`price-${this.VariantRadios.dataset.section}`)
    if (price) price.classList.add('visibility-hidden')
  }
  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.error
    this.errorMessage = this.errorMessage || this.errorMessageText
    if (this.errorMessageWrapper) this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)
    if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage
  }
  updateBundleFinalMessage() {
    let percentageMultiplier
    const bundleOriginalPrice = document.querySelector('.bundle_original_total_price')
    const bundleTotalPrice = document.querySelector('.bundle_subtotal_price')
    const bundleSavedPercentage = document.querySelector('.bundle_savings')
    const bundleProductPrice = parseInt(this.dataset.bundleProductPrice, 10)
    bundleProductPriceSum += bundleProductPrice
    if (bundleOriginalPrice) bundleOriginalPrice.innerHTML = Shopify.formatMoney(bundleProductPriceSum, Shopify.money_format)
    if (bundleSavedPercentage) {
      if (this.dataset.bundleType == 'set-of-2') {
        bundleSavedPercentage.innerHTML = '10%'
        percentageMultiplier = 0.900
      } else {
        bundleSavedPercentage.innerHTML = '15%'
        percentageMultiplier = 0.850
      }
    }
    bundleSavedSum += bundleProductPrice * percentageMultiplier
    if (bundleTotalPrice) bundleTotalPrice.innerHTML = Shopify.formatMoney(bundleSavedSum, Shopify.money_format)
  }
  onClickHandler(event) {
    if (this.button.classList.contains('loading')) return
    if (this.button.matches('.unavailable,.button-quick-buy__pre-order,.button-quick-buy__app-exclusive,.button-oos')) return
    event.preventDefault()
    const cartComponent = this.getCartComponent()
    this.variantIds = this.getAttribute('variant-ids')
    if (!this.variantIds) return
    this.handleErrorMessage()
    this.button.setAttribute('aria-disabled', true)
    this.button.classList.add('loading')
    const quantityEl = this.querySelector('input[name="quantity"]')
    const quantity = quantityEl ? Math.max(1, parseInt(quantityEl.value, 10) || 1) : 1
    let properties
    this.properties = this.getAttribute('line-item-props')
    if (this.properties) {
      try {
        properties = JSON.parse(this.properties)
        if (this.isBundlePage && properties._bundle) properties._bundle = properties._bundle + '-' + Math.floor(Math.random() * 1000000 + 1000)
      } catch (err) {
        console.error(err)
      }
    }
    const itemsObj = this.variantIds.split(',').map(varId => varId.trim()).filter(Boolean).map(varId => {
      return {
        id: varId,
        quantity: quantity,
        properties: properties ? { ...properties } : {}
      }
    })
    if (this.isGift === 'true' && itemsObj[0]) {
      itemsObj[0].properties = itemsObj[0].properties || {}
      itemsObj[0].properties._free_gift = 'true'
      itemsObj[0].properties._gwpType = 'collection'
      itemsObj[0].properties._giftId = 'collectiongift'
    }
    const body = { items: itemsObj }
    const sections = this.getSectionsForFetch(cartComponent)
    if (sections.length) {
      body.sections = sections
      body.sections_url = window.location.pathname
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
        return response.json()
      })
      .then(response => {
        if (response.status) {
          this.dispatchEvent(new CustomEvent('quick-buy-done', {
            bubbles: true,
            detail: { status: 'error', info: response }
          }))
          this.handleErrorMessage(response.description)
          return
        }
        this.dispatchEvent(new CustomEvent('quick-buy-done', {
          bubbles: true,
          detail: { status: 'success' }
        }))
        this.renderCartContents(cartComponent, response)
        this.button.classList.add('product-added')
        this.buttonText.innerHTML = 'ADDED'
        return fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }))
            return cart
          })
      })
      .catch(error => {
        console.error('Fetch error:', error)
        this.dispatchEvent(new CustomEvent('quick-buy-done', {
          bubbles: true,
          detail: { status: 'error', error: error }
        }))
      })
      .finally(() => {
        this.button.classList.remove('loading')
        this.button.removeAttribute('aria-disabled')
        if (this.isBundlePage) this.handleBundleStepAfterAdd()
      })
  }
  handleBundleStepAfterAdd() {
    this.updateBundleFinalMessage()
    setTimeout(() => {
      if (this.bundleGridStep == 1) {
        document.querySelector('#bundle_grid_step_2')?.classList.remove('hidden')
        document.querySelector('.bundle-grid-step-preview--2')?.classList.add('hidden')
        this.scrollToBundleStep('#bundle_grid_step_2')
      }
      if (this.bundleGridStep == 2 && this.dataset.bundleType === 'set-of-3') {
        document.querySelector('#bundle_grid_step_3')?.classList.remove('hidden')
        document.querySelector('.bundle-grid-step-preview--3')?.classList.add('hidden')
        this.scrollToBundleStep('#bundle_grid_step_3')
      }
      if ((this.bundleGridStep == 3 && this.dataset.bundleType === 'set-of-3') || (this.bundleGridStep == 2 && this.dataset.bundleType === 'set-of-2')) {
        document.querySelector('#bundle_step_final')?.classList.remove('hidden')
        this.scrollToBundleStep('#bundle_step_final')
      }
      setTimeout(() => document.querySelector('cart-drawer')?.classList.remove('active'), 700)
    }, 1300)
  }
  scrollToBundleStep(selector) {
    setTimeout(() => {
      document.querySelector(selector)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      })
    }, 150)
  }
  groupProductSetup(event) {
    event.preventDefault()
    this.classList.add('loading')
    this.querySelector('.loading-overlay.product-loading')?.classList.remove('hidden')
    const currentItem = this.colourGroup.querySelector('a.colour.current')
    const newItem = event.target
    const newItemUrl = event.target.href
    currentItem?.classList.remove('current')
    newItem.classList.add('current')
    this.newDataUrl = this.VariantRadios.getAttribute('data-url')
    if (newItemUrl.includes(this.newDataUrl)) {
      this.hideProductLoading()
      return
    }
  }
  groupProductSetTitle(html, event) {
    const titleParent = `.product-${this.VariantRadios.dataset.section} .product-title`
    const title = `.product-${this.VariantRadios.dataset.section} .product-title .product-title--simple`
    const titleSource = html.querySelector('.product__title')
    document.querySelectorAll(titleParent).forEach(titleDestination => {
      if (titleSource && titleDestination) {
        document.querySelector(title).innerHTML = titleSource.innerHTML
        titleDestination.setAttribute('href', event.target.href)
      }
    })
  }
  groupProductSetVariantTitle(html, event) {
    const variantTitleSelector = `.product-${this.VariantRadios.dataset.section} .product-variant`
    if (!this.currentVariant?.title || this.currentVariant.title === 'Default Title') return
    document.querySelectorAll(variantTitleSelector).forEach(variantTitleDestination => {
      variantTitleDestination.innerHTML = this.currentVariant.title
    })
  }
  groupProductSetPrice(html) {
    const price = `.product-${this.VariantRadios.dataset.section} .product-price`
    const priceSource = html.querySelector('.price')
    if (!priceSource) return
    document.querySelectorAll(price).forEach(priceDestination => {
      priceDestination.innerHTML = priceSource.innerHTML
      priceDestination.classList.remove('visibility-hidden')
    })
  }
  groupProductSetColour(html) {
    const colour = `.product-${this.VariantRadios.dataset.section} .product-colour`
    const colourSource = html.querySelector('.colour_label')
    if (!colourSource) return
    document.querySelectorAll(colour).forEach(colourDestination => {
      colourDestination.innerHTML = colourSource.innerHTML
    })
  }
  groupProductSetVariantData(html, event) {
    const variantIDSource = html.querySelector('.product-form input[type="hidden"][name="id"]')
    this.VariantRadios.setAttribute('data-url', event.target.href)
    if (variantIDSource) {
      this.setAttribute('variant-ids', variantIDSource.getAttribute('value'))
      this.variantIds = this.getAttribute('variant-ids')
    }
  }
  groupProductSetOptions(html) {
    const variantOptionsSource = html.querySelector('variant-radios')
    if (variantOptionsSource && this.VariantRadios) {
      this.VariantRadios.innerHTML = variantOptionsSource.innerHTML
      this.variantData = null
    }
  }
  groupProductSetMedia(html) {
    const mediaDataEl = html.querySelector('#product-image-data[type="application/json"]')
    if (!mediaDataEl) return
    this.mediaData = JSON.parse(mediaDataEl.textContent)
    if (this.mediaData[0]) this.updateMedia(this.mediaData[0].src)
    if (this.mediaData[1]) this.updateMediaSecond(this.mediaData[1].src)
  }
  groupProductSetTags(html) {
    const tag = `.product-${this.VariantRadios.dataset.section} .card__badges`
    const tagsSource = html.querySelector('.product-main-section .card__badges')
    if (!tagsSource) return
    document.querySelectorAll(tag).forEach(tagDestination => {
      tagDestination.innerHTML = tagsSource.innerHTML
    })
  }
  groupProductAdditionalDetail(html) {
    const detail = `.product-${this.VariantRadios.dataset.section} .product-additional-detail .desc`
    const detailSource = html.querySelector('.product-main-section .product__text.marketing-desc')
    const detailBundle = `.product-${this.VariantRadios.dataset.section} .product-additional-detail.bundle-additional-detail`
    const detailBundleSource = html.querySelector('.product-main-section .product__text.marketing-desc')
    if (document.querySelectorAll(detailBundle).length > 0) {
      document.querySelectorAll(detailBundle).forEach(detailDestination => {
        if (detailBundleSource && detailDestination) detailDestination.innerHTML = detailBundleSource.innerHTML
      })
      return
    }
    document.querySelectorAll(detail).forEach(detailDestination => {
      if (detailSource && detailDestination) detailDestination.innerHTML = detailSource.innerHTML
    })
    if (typeof Yotpo !== 'undefined' && typeof yotpo !== 'undefined') {
      var api = new Yotpo.API(yotpo)
      if (api) api.refreshWidgets()
    }
  }
  onClickHandlerGroupColor(event) {
    this.groupProductSetup(event)
    fetch(`${event.target.href}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        this.groupProductSetTitle(html, event)
        this.groupProductSetPrice(html)
        this.groupProductSetColour(html)
        this.groupProductSetVariantData(html, event)
        this.groupProductSetOptions(html)
        this.onProductChange()
        this.groupProductSetMedia(html)
        this.groupProductSetVariantTitle(html)
        this.groupProductSetTags(html)
        this.groupProductAdditionalDetail(html)
      })
      .finally(() => {
        this.hideProductLoading()
        if (window.BundleSelector) window.BundleSelector.handleSwatchClick(this, 'add', event)
        if (this.shadeTrigger) this.shadeTrigger.click()
      })
  }
}
customElements.define('quick-buy', QuickBuy)
class QuickBuySelects extends QuickBuy {
  constructor() {
    super()
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), select => select.value)
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => this.options[0].toString() === variant.id.toString())
  }
  groupProductSetOptions(html) {
    const variantOptionsDestination = this.VariantRadios.querySelector('.product-form__input--dropdown')
    const variantOptionsSource = html.querySelector('.quickbuy-dropdown-source')
    if (variantOptionsSource && variantOptionsDestination) {
      const variantOptionsSourceFormLabel = variantOptionsSource.querySelector('label.form__label')
      if (variantOptionsSourceFormLabel) variantOptionsSourceFormLabel.classList.add('hidden')
      variantOptionsDestination.innerHTML = variantOptionsSource.innerHTML
      this.variantData = null
    }
  }
  groupProductSetVariantData(html, event) {
    this.VariantRadios.setAttribute('data-url', event.target.href)
    const variantIDSource = html.querySelector('.product-form input[type="hidden"][name="id"]')
    if (variantIDSource) {
      this.setAttribute('variant-ids', variantIDSource.getAttribute('value'))
      this.variantIds = this.getAttribute('variant-ids')
    }
    const variantJsonSource = html.querySelector('variant-radios [type="application/json"]')
    const variantJsonDestination = this.VariantRadios.querySelector('[type="application/json"]')
    if (variantJsonSource && variantJsonDestination) {
      variantJsonDestination.textContent = variantJsonSource.textContent
      this.variantData = null
    }
  }
}
customElements.define('quick-buy-selects', QuickBuySelects)